var registerViewModel;
var companyCustomerTypeId = "1";
var privateCustomerTypeId = "2";

$(document).ready(function () {
    registerViewModel = new RegisterViewModel();
    var email = $("#tbxInitialEmail").val();
    var isDivisionEnabled = $("#IsDivisionEnabled").val();
    var isPrivateUserCustomerTypeDisabled = $("#IsPrivateUserCustomerTypeDisabled").val();
    var isCompanyUserCustomerTypeDisabled = $("#IsCompanyUserCustomerTypeDisabled").val();

    registerViewModel.DivisionEnabled(isDivisionEnabled === "true");
    ko.applyBindings(registerViewModel, document.getElementById('RegisterAccount'));

    registerViewModel.Email(email);
    registerViewModel.IsPrivateUserCustomerTypeDisabled(true);
    registerViewModel.IsPrivateUserCustomerTypeDisabled(isPrivateUserCustomerTypeDisabled === "True");
    registerViewModel.IsCompanyUserCustomerTypeDisabled(isCompanyUserCustomerTypeDisabled === "True");
});